import { ScrollDirections } from './Scroll.types';
class UIScrollAnimation {
    static fireScroll({ currentChildIndex, childs, pagesContainer, direction, onScrollEnd, animationDuration, }) {
        let nextOffset = 0, offest = 'offsetHeight', animation = 'translateY';
        if (direction === ScrollDirections.horizontal) {
            animation = 'translateX';
            offest = 'offsetWidth';
        }
        for (let i = 0; i < currentChildIndex; i++) {
            nextOffset += childs[i][offest];
        }
        pagesContainer.style.transform = `${animation}(${-nextOffset}px)`;
        setTimeout(() => {
            onScrollEnd();
        }, animationDuration);
        return this;
    }
}
export default UIScrollAnimation;
